<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('scope.text_756')}}</div>
    <div slot="body">
      <a-form
        :form="form.fc">
        <a-form-item :label="$t('scope.text_744')" v-bind="formItemLayout">
          <a-input v-decorator="decorators.invoice_code" :placeholder="$t('scope.text_757')" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_743')" v-bind="formItemLayout">
          <a-input v-decorator="decorators.invoice_no" :placeholder="$t('scope.text_758')" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'InvoicePrintDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      decorators: {
        invoice_code: [
          'invoice_code',
          {
            rules: [
              { required: true, message: this.$t('scope.text_757') },
            ],
          },
        ],
        invoice_no: [
          'invoice_no',
          {
            rules: [
              { required: true, message: this.$t('scope.text_758') },
            ],
          },
        ],
      },
    }
  },
  methods: {
    doPrint (data) {
      return this.params.onManager('performAction', {
        id: this.params.data[0].id,
        managerArgs: {
          action: 'print',
          data,
        },
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        await this.doPrint(values)
        this.loading = false
        this.cancelDialog()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
